import { render, staticRenderFns } from "./FontSizeRange.vue?vue&type=template&id=3fe46da4&scoped=true"
import script from "./FontSizeRange.vue?vue&type=script&lang=js"
export * from "./FontSizeRange.vue?vue&type=script&lang=js"
import style0 from "./FontSizeRange.vue?vue&type=style&index=0&id=3fe46da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe46da4",
  null
  
)

export default component.exports